import { useEffect, useRef } from 'react';
import { FullStory, init, isInitialized } from '@fullstory/browser';
import { useLocation } from 'react-router-dom';

const FULLSTORY_ORG_ID = process.env.REACT_APP_FULLSTORY_ORG_ID;
const TARGET_ROUTE = '/questions/home';

const isFullStoryReady = typeof window !== 'undefined' && Boolean(FULLSTORY_ORG_ID);

function FullStoryController() {
  const location = useLocation();
  const hasStartedCaptureRef = useRef(false);

  useEffect(() => {
    if (!isFullStoryReady) {
      return;
    }

    if (!isInitialized()) {
      init({
        orgId: FULLSTORY_ORG_ID,
        // Load SDK early but don't capture anything until target route is active.
        startCaptureManually: true,
      });
    }

    return () => {
      if (isInitialized()) {
        FullStory('shutdown');
      }
    };
  }, []);

  useEffect(() => {
    if (!isFullStoryReady || !isInitialized()) {
      return;
    }

    const isTargetRoute = location.pathname.includes(TARGET_ROUTE);

    if (isTargetRoute) {
      if (!hasStartedCaptureRef?.current) {
        FullStory('start');
        hasStartedCaptureRef.current = true;
      } else {
        FullStory('restart');
      }
    } else if (hasStartedCaptureRef?.current) {
      FullStory('shutdown');
      hasStartedCaptureRef.current = false;
    }
  }, [location.pathname]);

  return null;
}

export default FullStoryController;
